export const businessAccountManagers = [
  { key: 'chris.charla@microsoft.com', text: 'Chris Charla' },
  { key: 'rewaters@microsoft.com', text: 'Becca Waters' },
  { key: 'isaom@microsoft.com', text: 'Isao Murayama' },
  { key: 'v-tachic@microsoft.com', text: 'Tarah Chicas' },
];

export const businessProcessingManagers = [
  { key: 'v-anquig@microsoft.com', text: 'Anthony Quiggle' },
  { key: 'v-brlink@microsoft.com', text: 'Brandon Link' },
  { key: 'v-bribe@microsoft.com', text: 'Brian Bertsch' },
];

export const royaltyOperationsManagers = [
  { key: 'dawatana@microsoft.com', text: 'David Watanabe' },
  { key: 'mandyk@microsoft.com', text: 'Mandy Kalirai' },
  { key: 'shhall@microsoft.com', text: 'Shawna Hall' },
  { key: 'gailr@microsoft.com', text: 'Gail Rawlings' },
];

export const royaltyAnalysts = [
  { key: 'v-bribe@microsoft.com', text: 'Brian Bertsch' },
  { key: 'v-karatw@microsoft.com', text: 'Kara Tweed' },
  { key: 'v-muakht@microsoft.com', text: 'Muhammad Akhtar' },
  { key: 'v-thklic@microsoft.com', text: 'Theresa Klicker' },
  { key: 'v-pablad@microsoft.com', text: 'Paige Bladow' },
];

export const statementFrequency = [
  { key: 'month', text: 'Monthly' },
  { key: 'quarter', text: 'Quarterly' },
];

export const platforms = [{ key: 'Xbox One', text: 'Xbox One' }];

export const silos = [
  {
    key: '3p-tla',
    text: '3P TLA',
  },
  {
    key: '1p-azure',
    text: '1P Azure',
  },
];

export const adjustmentTypes = [
  {
    key: 'AdjustmentToRoyaltiesEarned',
    text: 'Royalties Earned',
    listItemsName: 'adjustments',
  },
  {
    key: 'RecoupablePayment',
    text: 'Recoupable Payment',
    listItemsName: 'recoupablePayments',
  },
  {
    key: 'NonRecoupablePayment',
    text: 'Non-Recoupable Payment',
    listItemsName: 'nonRecoupablePayments',
  },
  {
    key: 'AdvanceBalance',
    text: 'Advance Balance',
    listItemsName: 'advanceBalanceAdjustments',
  },
];

export const geographies = [
  { key: 'CTY_CAN', text: 'CAN' },
  { key: 'CTY_USA', text: 'USA' },
  { key: 'CTY_ARG', text: 'ARG' },
  { key: 'CTY_BRA', text: 'BRA' },
  { key: 'CTY_CHL', text: 'CHL' },
  { key: 'CTY_COL', text: 'COL' },
  { key: 'CTY_CRI', text: 'CRI' },
  { key: 'CTY_MEX', text: 'MEX' },
  { key: 'CTY_PER', text: 'PER' },
];

export const channels = [
  { key: 'ChannelID', text: 'descr' },
  { key: 'Untitled', text: 'Untitled' },
  { key: 'Unspecified', text: 'Unspecified' },
  { key: 'RETAILER', text: 'CT_Retailer' },
  { key: 'RETAIL DUMMY', text: 'Retail Dummy' },
  { key: 'MARKETPLACE CONTENT DUMMY', text: 'Marketplace Content Dummy' },
  { key: 'CT_ONLINE', text: 'CT_Online' },
  { key: 'REDCOSTORE', text: 'Redmond Company Store' },
  { key: 'IRLCOSTORE', text: 'Ireland Company Store' },
  { key: 'JPNCOSTORE', text: 'Japan Company Store' },
  { key: 'N/A', text: 'N/A' },
  { key: 'FG', text: 'FG' },
  { key: 'OEM', text: 'OEM' },
  { key: 'MSP', text: 'Press' },
  { key: 'ONL', text: 'Online' },
  { key: 'OAT', text: 'Softimage' },
  { key: 'OR', text: 'OEM-Retail' },
  { key: 'SVC', text: 'Service' },
  { key: 'MBS', text: 'MBS Services' },
  { key: 'CAP', text: 'MS Capital' },
  { key: 'C_RetailPosaPrinting', text: 'RetailPosaPrinting' },
  { key: 'C_MarketPlace', text: 'MarketPlace' },
  { key: 'C_Etailer', text: 'Etailer' },
  { key: 'C_Retailer', text: 'Retailer' },
  { key: 'C_InternalMarketing', text: 'InternalMarketing' },
  { key: 'C_ExternalMarketing', text: 'ExternalMarketing' },
  { key: 'C_DigitalFillngStation', text: 'DigitalFillngStation' },
  { key: 'C_XboxMarketplaceDirect', text: 'XboxMarketplaceDirect' },
  { key: 'CT_MOBILE', text: 'CT_Mobile' },
  { key: 'C_MOBILE_MARKETPLACE', text: 'MOBILE_MARKETPLACE' },
  { key: 'C_Retail FPP', text: 'Retail FPP' },
  { key: 'C_Retail POSA', text: 'Retail POSA' },
  { key: 'C_Promo Direct', text: 'Promo Direct' },
  { key: 'C_Promo External', text: 'Promo External' },
  { key: 'C_Other', text: 'Other' },
  { key: 'CT_AGENCY', text: 'CT_Agency' },
  { key: 'CT_ADVERTISING', text: 'CT_Advertising' },
  { key: 'Agency_RetailPosaPrinting', text: 'Agency_RetailPosaPrinting' },
  { key: 'Agency_MarketPlace', text: 'Agency_MarketPlace' },
  { key: 'Agency_Etailer', text: 'Agency_Etailer' },
  { key: 'Agency_Retailer', text: 'Agency_Retailer' },
  { key: 'Agency_InternalMarketing', text: 'Agency_InternalMarketing' },
  { key: 'Agency_ExternalMarketing', text: 'Agency_ExternalMarketing' },
  { key: 'Agency_DigitalFillngStation', text: 'Agency_DigitalFillngStation' },
  { key: 'Agency_XboxMarketplaceDirect', text: 'Agency_XboxMarketplaceDirect' },
  { key: 'Agency_MOBILE_MARKETPLACE', text: 'Agency_MOBILE_MARKETPLACE' },
  { key: 'Agency_Retail FPP', text: 'Agency_Retail FPP' },
  { key: 'Agency_Retail POSA', text: 'Agency_Retail POSA' },
  { key: 'Agency_Promo Direct', text: 'Agency_Promo Direct' },
  { key: 'Agency_Promo External', text: 'Agency_Promo External' },
  { key: 'Agency_Other', text: 'Agency_Other' },
  { key: 'Advertising', text: 'Advertising' },
  { key: 'CT_WEBADGAMING', text: 'CT_WebAdGaming' },
  { key: 'WEB ADVERTISING', text: 'Web Advertising' },
  { key: 'WEB SPONSORSHIP', text: 'Web Sponsorship' },
  { key: 'HKGCOSTORE', text: 'Hong Kong Company Store' },
  { key: 'SGPCOSTORE', text: 'Singapore Company Store' },
  { key: 'MYSCOSTORE', text: 'Malaysia Company Store' },
  { key: 'AUSCOSTORE', text: 'Australia Company Store' },
  { key: 'KORCOSTORE', text: 'Korea Company Store' },
  { key: 'NZLCOSTORE', text: 'New Zealand Company Store' },
  { key: 'TWNCOSTORE', text: 'Taiwan Company Store' },
  { key: 'EMEACOSTORE', text: 'EMEA Company Store' },
  { key: 'ADVERTISING DUMMY', text: 'Advertising Dummy' },
  { key: 'AGENCY DUMMY', text: 'Agency Dummy' },
  { key: 'WEB AD DUMMY', text: 'Web Ad Dummy' },
  { key: 'C_MODERN MARKETPLACE', text: 'MODERN MARKETPLACE' },
  { key: 'Agency_MODERN MARKETPLACE', text: 'Agency_MODERN MARKETPLACE' },
  { key: 'CT_PREMIUMSUBSCRIPTION', text: 'CT_PremiumSubscription' },
  { key: 'C_Video', text: 'Video' },
  { key: 'Agency_Video', text: 'Agency_Video' },
  { key: 'Bing_Advertising', text: 'Bing_Advertising' },
  { key: 'C_UNIVERSALSTORE_MARKETPLACE', text: 'UNIVERSALSTORE_MARKETPLACE' },
  { key: 'Agency_UNIVERSALSTORE_MARKETPLACE', text: 'Agency_UNIVERSALSTORE_MARKETPLACE' },
  { key: 'O365', text: 'O365' },
  { key: 'ASG_Advertising', text: 'ASG_Advertising' },
];

export const currencies = [
  { key: 'AED', text: 'AED' },
  { key: 'AFN', text: 'AFN' },
  { key: 'ALL', text: 'ALL' },
  { key: 'AMD', text: 'AMD' },
  { key: 'ANG', text: 'ANG' },
  { key: 'AOA', text: 'AOA' },
  { key: 'ARS', text: 'ARS' },
  { key: 'ATS', text: 'ATS' },
  { key: 'AUD', text: 'AUD' },
  { key: 'AZN', text: 'AZN' },
  { key: 'BAM', text: 'BAM' },
  { key: 'BBD', text: 'BBD' },
  { key: 'BDT', text: 'BDT' },
  { key: 'BEF', text: 'BEF' },
  { key: 'BGN', text: 'BGN' },
  { key: 'BHD', text: 'BHD' },
  { key: 'BIF', text: 'BIF' },
  { key: 'BMD', text: 'BMD' },
  { key: 'BND', text: 'BND' },
  { key: 'BOB', text: 'BOB' },
  { key: 'BRL', text: 'BRL' },
  { key: 'BSD', text: 'BSD' },
  { key: 'BTN', text: 'BTN' },
  { key: 'BWP', text: 'BWP' },
  { key: 'BYN', text: 'BYN' },
  { key: 'BZD', text: 'BZD' },
  { key: 'CAD', text: 'CAD' },
  { key: 'CDF', text: 'CDF' },
  { key: 'CHF', text: 'CHF' },
  { key: 'CLP', text: 'CLP' },
  { key: 'CNH', text: 'CNH' },
  { key: 'CNY', text: 'CNY' },
  { key: 'COP', text: 'COP' },
  { key: 'CRC', text: 'CRC' },
  { key: 'CSD', text: 'CSD' },
  { key: 'CVE', text: 'CVE' },
  { key: 'CYP', text: 'CYP' },
  { key: 'CZK', text: 'CZK' },
  { key: 'DEM', text: 'DEM' },
  { key: 'DJF', text: 'DJF' },
  { key: 'DKK', text: 'DKK' },
  { key: 'DOP', text: 'DOP' },
  { key: 'DZD', text: 'DZD' },
  { key: 'EEK', text: 'EEK' },
  { key: 'EGP', text: 'EGP' },
  { key: 'ERN', text: 'ERN' },
  { key: 'ESP', text: 'ESP' },
  { key: 'ETB', text: 'ETB' },
  { key: 'EUR', text: 'EUR' },
  { key: 'FIM', text: 'FIM' },
  { key: 'FJD', text: 'FJD' },
  { key: 'FRF', text: 'FRF' },
  { key: 'GBP', text: 'GBP' },
  { key: 'GEL', text: 'GEL' },
  { key: 'GHS', text: 'GHS' },
  { key: 'GIP', text: 'GIP' },
  { key: 'GMD', text: 'GMD' },
  { key: 'GNF', text: 'GNF' },
  { key: 'GRD', text: 'GRD' },
  { key: 'GTQ', text: 'GTQ' },
  { key: 'GYD', text: 'GYD' },
  { key: 'HKD', text: 'HKD' },
  { key: 'HNL', text: 'HNL' },
  { key: 'HRK', text: 'HRK' },
  { key: 'HTG', text: 'HTG' },
  { key: 'HUF', text: 'HUF' },
  { key: 'IDR', text: 'IDR' },
  { key: 'IEP', text: 'IEP' },
  { key: 'ILS', text: 'ILS' },
  { key: 'INR', text: 'INR' },
  { key: 'IQD', text: 'IQD' },
  { key: 'ISK', text: 'ISK' },
  { key: 'ITL', text: 'ITL' },
  { key: 'JMD', text: 'JMD' },
  { key: 'JOD', text: 'JOD' },
  { key: 'JPY', text: 'JPY' },
  { key: 'KES', text: 'KES' },
  { key: 'KGS', text: 'KGS' },
  { key: 'KHR', text: 'KHR' },
  { key: 'KMF', text: 'KMF' },
  { key: 'KRW', text: 'KRW' },
  { key: 'KTS', text: 'KTS' },
  { key: 'KWD', text: 'KWD' },
  { key: 'KYD', text: 'KYD' },
  { key: 'KZT', text: 'KZT' },
  { key: 'LAK', text: 'LAK' },
  { key: 'LBP', text: 'LBP' },
  { key: 'LKR', text: 'LKR' },
  { key: 'LRD', text: 'LRD' },
  { key: 'LSL', text: 'LSL' },
  { key: 'LTL', text: 'LTL' },
  { key: 'LVL', text: 'LVL' },
  { key: 'LYD', text: 'LYD' },
  { key: 'MAD', text: 'MAD' },
  { key: 'MDL', text: 'MDL' },
  { key: 'MGA', text: 'MGA' },
  { key: 'MKD', text: 'MKD' },
  { key: 'MMK', text: 'MMK' },
  { key: 'MNT', text: 'MNT' },
  { key: 'MOP', text: 'MOP' },
  { key: 'MRO', text: 'MRO' },
  { key: 'MTL', text: 'MTL' },
  { key: 'MUR', text: 'MUR' },
  { key: 'MVR', text: 'MVR' },
  { key: 'MWK', text: 'MWK' },
  { key: 'MXN', text: 'MXN' },
  { key: 'MYR', text: 'MYR' },
  { key: 'MZN', text: 'MZN' },
  { key: 'NAD', text: 'NAD' },
  { key: 'NGN', text: 'NGN' },
  { key: 'NIO', text: 'NIO' },
  { key: 'NLG', text: 'NLG' },
  { key: 'NOK', text: 'NOK' },
  { key: 'NPR', text: 'NPR' },
  { key: 'NZD', text: 'NZD' },
  { key: 'OMR', text: 'OMR' },
  { key: 'PAB', text: 'PAB' },
  { key: 'PEN', text: 'PEN' },
  { key: 'PGK', text: 'PGK' },
  { key: 'PHP', text: 'PHP' },
  { key: 'PKR', text: 'PKR' },
  { key: 'PLN', text: 'PLN' },
  { key: 'PTE', text: 'PTE' },
  { key: 'PYG', text: 'PYG' },
  { key: 'QAR', text: 'QAR' },
  { key: 'RON', text: 'RON' },
  { key: 'RSD', text: 'RSD' },
  { key: 'RUB', text: 'RUB' },
  { key: 'RWF', text: 'RWF' },
  { key: 'SAR', text: 'SAR' },
  { key: 'SBD', text: 'SBD' },
  { key: 'SCR', text: 'SCR' },
  { key: 'SEK', text: 'SEK' },
  { key: 'SGD', text: 'SGD' },
  { key: 'SIT', text: 'SIT' },
  { key: 'SKK', text: 'SKK' },
  { key: 'SLL', text: 'SLL' },
  { key: 'SRD', text: 'SRD' },
  { key: 'SZL', text: 'SZL' },
  { key: 'THB', text: 'THB' },
  { key: 'TMT', text: 'TMT' },
  { key: 'TND', text: 'TND' },
  { key: 'TOP', text: 'TOP' },
  { key: 'TRY', text: 'TRY' },
  { key: 'TTD', text: 'TTD' },
  { key: 'TWD', text: 'TWD' },
  { key: 'TZS', text: 'TZS' },
  { key: 'UAH', text: 'UAH' },
  { key: 'UAK', text: 'UAK' },
  { key: 'UGX', text: 'UGX' },
  { key: 'USD', text: 'USD' },
  { key: 'UYU', text: 'UYU' },
  { key: 'UZS', text: 'UZS' },
  { key: 'VEF', text: 'VEF' },
  { key: 'VND', text: 'VND' },
  { key: 'VUV', text: 'VUV' },
  { key: 'WST', text: 'WST' },
  { key: 'XAF', text: 'XAF' },
  { key: 'XCD', text: 'XCD' },
  { key: 'XEU', text: 'XEU' },
  { key: 'XOF', text: 'XOF' },
  { key: 'XPF', text: 'XPF' },
  { key: 'YER', text: 'YER' },
  { key: 'YUM', text: 'YUM' },
  { key: 'ZAR', text: 'ZAR' },
  { key: 'ZMW', text: 'ZMW' },
];

export const purchaseOrigin = [
  { key: 'PCandOther', text: 'PCandOther' },
  { key: 'Xbox', text: 'Xbox' },
];

export const customerTier = [
  { key: 'Hard deck', text: 'Hard deck' },
  { key: 'Standard', text: 'Standard' },
  { key: 'VMCU', text: 'VMCU' },
  { key: '', text: 'General' },
];

export const inclusions = [
  { key: 'exclude', text: 'Exclude' },
  { key: 'include', text: 'Include' },
];

export const purchaseClassificationCodes = [
  { key: '93131605', text: '93131605' },
  { key: '93151517', text: '93151517' },
  { key: '81111500', text: '81111500' },
  { key: '43201820', text: '43201820' },
  { key: '43201819', text: '43201819' },
];

export const companyCodes = [
  { key: '1010', text: '1010' },
  { key: '1062', text: '1062' },
  { key: '1548', text: '1548' },
];

export const taxCodes = [
  { key: 'TAX N/A', text: 'TAX N/A' },
  { key: '30% WHT ROY', text: '30% WHT ROY' },
  { key: '5% WHT ROY/EIN/AS', text: '5% WHT ROY/EIN/AS' },
  { key: '1042/ROY/EIN/AU', text: '1042/ROY/EIN/AU' },
  { key: '10% WHT ROY/EIN/BG', text: '10% WHT ROY/EIN/BG' },
  { key: '5% WHT ROY/EIN/BB', text: '5% WHT ROY/EIN/BB' },
  { key: '1042/ROY/EIN/BE', text: '1042/ROY/EIN/BE' },
  { key: '1042/ROY/EIN/CA', text: '1042/ROY/EIN/CA' },
  { key: '10% WHT ROY/EIN/CH', text: '10% WHT ROY/EIN/CH' },
  { key: '1042/ROY/EIN/CY', text: '1042/ROY/EIN/CY' },
  { key: '1042/ROY/EIN/EZ', text: '1042/ROY/EIN/EZ' },
  { key: '1042/ROY/EIN/DA', text: '1042/ROY/EIN/DA' },
  { key: '15% WHT ROY/EIN/EG', text: '15% WHT ROY/EIN/EG' },
  { key: '10% WHT ROY/EIN/EN', text: '10% WHT ROY/EIN/EN' },
  { key: '1042/ROY/EIN/FI', text: '1042/ROY/EIN/FI' },
  { key: '1042/ROY/EIN/FR', text: '1042/ROY/EIN/FR' },
  { key: '1042/ROY/EIN/GM', text: '1042/ROY/EIN/GM' },
  { key: '1042/ROY/EIN/GR', text: '1042/ROY/EIN/GR' },
  { key: '1042/ROY/EIN/HU', text: '1042/ROY/EIN/HU' },
  { key: '1042/ROY/EIN/IC', text: '1042/ROY/EIN/IC' },
  { key: '15% WHT ROY/EIN/IN', text: '15% WHT ROY/EIN/IN' },
  { key: '10% WHT ROY/EIN/ID', text: '10% WHT ROY/EIN/ID' },
  { key: '1042/ROY/EIN/EI', text: '1042/ROY/EIN/EI' },
  { key: '10% WHT ROY/EIN/IS', text: '10% WHT ROY/EIN/IS' },
  { key: '5% WHT ROY/EIN/IT', text: '5% WHT ROY/EIN/IT' },
  { key: '10% WHT ROY/EIN/JM', text: '10% WHT ROY/EIN/JM' },
  { key: '1042/ROY/EIN/JA', text: '1042/ROY/EIN/JA' },
  { key: '10% WHT ROY/EIN/KZ', text: '10% WHT ROY/EIN/KZ' },
  { key: '10% WHT ROY/EIN/KS', text: '10% WHT ROY/EIN/KS' },
  { key: '10% WHT ROY/EIN/LG', text: '10% WHT ROY/EIN/LG' },
  { key: '10% WHT ROY/EIN/LH', text: '10% WHT ROY/EIN/LH' },
  { key: '1042/ROY/EIN/LU', text: '1042/ROY/EIN/LU' },
  { key: '10% WHT ROY/EIN/MX', text: '10% WHT ROY/EIN/MX' },
  { key: '10% WHT ROY/EIN/MO', text: '10% WHT ROY/EIN/MO' },
  { key: '1042/ROY/EIN/NL', text: '1042/ROY/EIN/NL' },
  { key: '5% WHT ROY/EIN/NZ', text: '5% WHT ROY/EIN/NZ' },
  { key: '1042/ROY/EIN/NO', text: '1042/ROY/EIN/NO' },
  { key: '1042/ROY/EIN/PK', text: '1042/ROY/EIN/PK' },
  { key: '15% WHT ROY/EIN/RP', text: '15% WHT ROY/EIN/RP' },
  { key: '10% WHT ROY/EIN/PL', text: '10% WHT ROY/EIN/PL' },
  { key: '10% WHT ROY/EIN/PO', text: '10% WHT ROY/EIN/PO' },
  { key: '10% WHT ROY/EIN/RO', text: '10% WHT ROY/EIN/RO' },
  { key: '1042/ROY/EIN/RS', text: '1042/ROY/EIN/RS' },
  { key: '1042/ROY/EIN/LO', text: '1042/ROY/EIN/LO' },
  { key: '5% WHT ROY/EIN/SI', text: '5% WHT ROY/EIN/SI' },
  { key: '1042/ROY/EIN/SF', text: '1042/ROY/EIN/SF' },
  { key: '5% WHT ROY/EIN/SP', text: '5% WHT ROY/EIN/SP' },
  { key: '10% WHT ROY/EIN/CE', text: '10% WHT ROY/EIN/CE' },
  { key: '1042/ROY/EIN/SW', text: '1042/ROY/EIN/SW' },
  { key: '1042/ROY/EIN/SZ', text: '1042/ROY/EIN/SZ' },
  { key: '5% WHT ROY/EIN/TH', text: '5% WHT ROY/EIN/TH' },
  { key: '1042/ROY/EIN/TD', text: '1042/ROY/EIN/TD' },
  { key: '15% WHT ROY/EIN/TS', text: '15% WHT ROY/EIN/TS' },
  { key: '10% WHT ROY/EIN/TU', text: '10% WHT ROY/EIN/TU' },
  { key: '10% WHT ROY/EIN/UP', text: '10% WHT ROY/EIN/UP' },
  { key: '1042/ROY/EIN/UK', text: '1042/ROY/EIN/UK' },
  { key: '10% WHT ROY/EIN/VE', text: '10% WHT ROY/EIN/VE' },
  { key: '1042/ROY/EIN/CIS ', text: '1042/ROY/EIN/CIS ' },
  { key: 'NP WHT/IP – DO NOT USE', text: 'NP WHT/IP – DO NOT USE' },
  { key: '1042/ROY/EIN/IT', text: '1042/ROY/EIN/IT' },
  { key: '15% WHT ROY/EIN/IL', text: '15% WHT ROY/EIN/IL' },
  { key: '10% WHT ROY/EIN/IL', text: '10% WHT ROY/EIN/IL' },
  { key: 'NO WHT ROY/Sold O/S USA', text: 'NO WHT ROY/Sold O/S USA' },
  { key: '5% WHT ROY/EIN/BU', text: '5% WHT ROY/EIN/BU' },
  { key: '15% WHT ROY/EIN/IS', text: '15% WHT ROY/EIN/IS' },
  { key: '10% WHT ROY/EIN/MT', text: '10% WHT ROY/EIN/MT' },
  { key: '10% WHT ROY/EIN/AU', text: '10% WHT ROY/EIN/AU' },
  { key: '10% WHT ROY/EIN/CA', text: '10% WHT ROY/EIN/CA' },
  { key: '1042/ROY/EIN/EG', text: '1042/ROY/EIN/EG' },
  { key: 'WHT ROY/Sold I/S US', text: 'WHT ROY/Sold I/S US' },
  { key: '8% WHT ROY/EIN/IT', text: '8% WHT ROY/EIN/IT' },
  { key: '8% WHT ROY/EIN/SP', text: '8% WHT ROY/EIN/SP' },
];

export const bundleTypes = [
  { key: 'Digital', text: 'Digital' },
  { key: 'Soft Bundle', text: 'Soft Bundle' },
  { key: 'Retail', text: 'Retail' },
];

export const orphanBundleContent = {
  type: 'error',
  title: 'Existing Transactions On The Product Bundle',
  content:
    'Please review and adjust the proposed effective date range revision. There are existing transactions on the product bundle that are no longer in scope for the bundle effective date range which will result in orphaned transactions.',
  button: 'Close',
  showCancelButton: false,
  submitType: 'close',
};

export const bundleReprocessContent = {
  type: 'reprocess',
  title: 'Bundle Revision May Cause Reprocessing',
  content:
    'Effective Start Date selected is a historical date which may trigger a transaction reprocessing event for this product bundle.',
  button: 'Agree',
  showCancelButton: true,
  submitType: 'save',
};

const calcParamTypesForAgreement = [
  { key: 'percentageRevenue', text: '% Revenue' },
  { key: 'percentagePrice', text: '% Price' },
  { key: 'unitRate', text: 'Unit Rate' },
];

export const getCalcParamsText = calcParams => {
  const calcParamTypeForAgreement = calcParamTypesForAgreement.find(e => e.key === calcParams);
  return calcParamTypeForAgreement ? calcParamTypeForAgreement.text : calcParams;
};

export const dimensionListTypes = [
  { key: 'activityType', text: 'Activity Type' },
  { key: 'channel', text: 'Channel' },
  { key: 'currency', text: 'Currency Code' },
  { key: 'geography', text: 'Geography' },
  { key: 'offerId', text: 'Offer Id' },
  { key: 'product', text: 'Product' },
  { key: 'productTypeId', text: 'Product Type' },
  { key: 'resourceGuid', text: 'Resource Guid' },
  { key: 'saleType', text: 'Sale Type' },
  { key: 'unitOfMeasure', text: 'Unit of Measure' },
  { key: 'dataCenter', text: 'Data Center' },
  { key: 'subscriptionGuid', text: 'Subscription Guid' },
  { key: 'tpId', text: 'TPID' },
  { key: 'customerId', text: 'Customer Id' },
];

export const computedValueTypes = [
  { key: 'cancellationDaysSincePurchased', text: 'Eligibility' },
  { key: '>30Days', text: 'Greater than 30 days' },
  { key: '<=30Days', text: 'Within 30 days' },
];

export const deleteBundleContent = {
  type: 'delete',
  title: 'Delete this bundle?',
  content: 'Are you sure you wish to delete',
  button: 'Yes, Delete Bundle',
  showCancelButton: true,
};

export const deleteDimensionContent = {
  type: 'delete',
  title: 'Delete this list?',
  content: 'The list will be permanently deleted. This action cannot be undone.',
  button: 'Yes, Delete',
  showCancelButton: true,
};

export const deleteRoleContent = {
  type: 'delete',
  title: 'Delete this Role?',
  content: 'The role will be permanently deleted. This action cannot be undone.',
  button: 'Yes, Delete',
  showCancelButton: true,
};

export const mandatoryRoles = ['msft', 'partner', 'admin'];

export const dateValidationMessage = `Validation failed : "endDate" must be greater than "ref:startDate"`;

export const filterOptions = {
  product: [
    { key: 'productName', text: 'Product Name', isListOption: false, placeHolder: 'products' },
    { key: 'productTokenId', text: 'Token Id', isListOption: true, placeHolder: 'products' },
    { key: 'productId', text: 'Product Id', isListOption: true, placeHolder: 'products' },
    { key: 'listName', text: 'Product List Name', isListOption: true, placeHolder: 'lists' },
  ],
  currency: [
    { key: 'currencyName', text: 'Name', isListOption: false, placeHolder: 'currencies' },
    { key: 'currencyCode', text: 'ID', isListOption: false, placeHolder: 'currencies' },
    { key: 'listName', text: 'Currency List Name', isListOption: true, placeHolder: 'lists' },
  ],
  geography: [
    { key: 'countryName', text: 'Name', isListOption: false, placeHolder: 'geographies' },
    { key: 'countryCode', text: 'ID', isListOption: false, placeHolder: 'geographies' },
    { key: 'listName', text: 'Geography List Name', isListOption: true, placeHolder: 'lists' },
  ],
  channel: [
    { key: 'channelTypeName', text: 'Name', isListOption: false, placeHolder: 'channels' },
    { key: 'derivedName', text: 'ID', isListOption: false, placeHolder: 'channels' },
    { key: 'listName', text: 'Channel List Name', isListOption: true, placeHolder: 'lists' },
  ],
  productTypeId: [
    {
      key: 'productTypeDescription',
      text: 'Name',
      isListOption: false,
      placeHolder: 'product types',
    },
    { key: 'productTypeId', text: 'ID', isListOption: true, placeHolder: 'product types' },
    { key: 'listName', text: 'Product Type List Name', isListOption: true, placeHolder: 'lists' },
  ],
  activityType: [
    {
      key: 'activityTypeDescription',
      text: 'Name',
      isListOption: false,
      placeHolder: 'activity types',
    },
    { key: 'activityTypeId', text: 'ID', isListOption: true, placeHolder: 'activity types' },
    { key: 'listName', text: 'Activity List Name', isListOption: true, placeHolder: 'lists' },
  ],
  saleType: [
    { key: 'saleTypeDescription', text: 'Name', isListOption: false, placeHolder: 'sale types' },
    { key: 'saleTypeId', text: 'ID', isListOption: true, placeHolder: 'sale types' },
    { key: 'listName', text: 'Sale List Name', isListOption: true, placeHolder: 'lists' },
  ],
  dataCenter: [
    { key: 'azureDatacenters', text: 'Name', isListOption: false, placeHolder: 'Data Centers' },
    { key: 'azureDatacentersId', text: 'ID', isListOption: true, placeHolder: 'Data Centers' },
    { key: 'listName', text: 'Data center List Name', isListOption: true, placeHolder: 'lists' },
  ],
};

export const dLTypeValues = {
  product: {
    sortColumn: 'tokenId',
    route: 'products',
    results: 'search.results',
    hierarchy: true,
  },
  currency: {
    sortColumn: 'CurrencyCode',
    route: 'currencies',
    results: 'search.results',
    hierarchy: false,
  },
  geography: {
    sortColumn: 'ISOCountryNumber',
    route: 'geographies',
    results: 'search.results',
    hierarchy: false,
  },
  channel: {
    sortColumn: 'DerivedName',
    route: 'channels',
    results: 'search.results',
    hierarchy: false,
  },
  productTypeId: {
    sortColumn: 'ProductTypeId',
    route: 'product-types',
    results: 'search.results',
    hierarchy: false,
  },
  activityType: {
    sortColumn: 'ActivityTypeId',
    route: 'activity-types',
    results: 'search.results',
    hierarchy: false,
  },
  saleType: {
    sortColumn: 'SaleTypeId',
    route: 'sale-types',
    results: 'search.results',
    hierarchy: false,
  },
  offerId: {
    sortColumn: 'OfferId',
    route: 'offerId',
    isTextField: true,
    results: 'search.results',
    hierarchy: false,
  },
  resourceGuid: {
    sortColumn: 'ResourceGuid',
    isTextField: true,
    route: 'resourceGuid',
    results: 'search.results',
    hierarchy: false,
  },
  dataCenter: {
    sortColumn: 'AzureDatacenters',
    route: 'dataCenters',
    results: 'search.results',
    hierarchy: false,
  },
  subscriptionGuid: {
    sortColumn: 'SubscriptionGuid',
    isTextField: true,
    route: 'subscriptionGuids',
    results: 'search.results',
    hierarchy: false,
  },
  tpId: {
    sortColumn: 'TPID',
    isTextField: true,
    route: 'tpId',
    results: 'search.results',
    hierarchy: false,
  },
  customerId: {
    sortColumn: 'CustomerId',
    isTextField: true,
    route: 'customerId',
    results: 'search.results',
    hierarchy: false,
  },
};

export const individualItemsColumnHeaders = {
  product: {
    column1: { key: 'name', name: 'Product Name', fieldName: 'name' },
    column2: { key: 'tokenId', name: 'ID', fieldName: 'tokenId' },
    column3: { key: 'view', name: 'view' },
  },
  currency: {
    column1: { key: 'name', name: 'Item Name', fieldName: 'currencyName' },
    column2: { key: 'id', name: 'ID', fieldName: 'currencyCode' },
  },
  geography: {
    column1: { key: 'name', name: 'Item Name', fieldName: 'countryName' },
    column2: { key: 'id', name: 'ID', fieldName: 'countryCode' },
  },
  channel: {
    column1: { key: 'name', name: 'Item Name', fieldName: 'channelTypeName' },
    column2: { key: 'id', name: 'ID', fieldName: 'derivedName' },
  },
  productTypeId: {
    column1: { key: 'name', name: 'Item Name', fieldName: 'productTypeDescription' },
    column2: { key: 'id', name: 'ID', fieldName: 'productTypeId' },
  },
  activityType: {
    column1: { key: 'name', name: 'Item Name', fieldName: 'activityTypeDescription' },
    column2: { key: 'id', name: 'ID', fieldName: 'activityTypeId' },
  },
  saleType: {
    column1: { key: 'name', name: 'Item Name', fieldName: 'saleTypeDescription' },
    column2: { key: 'id', name: 'ID', fieldName: 'saleTypeId' },
  },
  dataCenter: {
    column1: { key: 'name', name: 'Item Name', fieldName: 'azureDatacenters' },
    column2: { key: 'id', name: 'ID', fieldName: 'azureDatacentersId' },
  },
};

export const listColumnHeaders = {
  product: {
    column1: { key: 'name', name: 'Product Name', fieldName: 'name' },
    column2: { key: 'tokenId', name: 'ID', fieldName: 'id' },
    column3: { key: 'view', name: 'view' },
  },
  currency: {
    column1: { key: 'name', name: 'Item Name', fieldName: 'name' },
    column2: { key: 'id', name: 'ID', fieldName: 'id' },
  },
  geography: {
    column1: { key: 'name', name: 'Item Name', fieldName: 'name' },
    column2: { key: 'id', name: 'ID', fieldName: 'id' },
  },
  channel: {
    column1: { key: 'name', name: 'Item Name', fieldName: 'name' },
    column2: { key: 'id', name: 'ID', fieldName: 'id' },
  },
  productTypeId: {
    column1: { key: 'name', name: 'Item Name', fieldName: 'name' },
    column2: { key: 'id', name: 'ID', fieldName: 'id' },
  },
  offerId: {
    column1: { key: 'name', name: 'Item Name', fieldName: 'name' },
  },
  activityType: {
    column1: { key: 'name', name: 'Item Name', fieldName: 'name' },
    column2: { key: 'id', name: 'ID', fieldName: 'id' },
  },
  saleType: {
    column1: { key: 'name', name: 'Item Name', fieldName: 'name' },
    column2: { key: 'id', name: 'ID', fieldName: 'id' },
  },
  resourceGuid: {
    column1: { key: 'name', name: 'Item Name', fieldName: 'name' },
    column2: { key: 'id', name: 'ID', fieldName: 'id' },
  },
  dataCenter: {
    column1: { key: 'name', name: 'Item Name', fieldName: 'name' },
    column2: { key: 'id', name: 'ID', fieldName: 'id' },
  },
  subscriptionGuid: {
    column1: { key: 'name', name: 'Item Name', fieldName: 'name' },
    column2: { key: 'id', name: 'ID', fieldName: 'id' },
  },
  tpId: {
    column1: { key: 'name', name: 'Item Name', fieldName: 'name' },
    column2: { key: 'id', name: 'ID', fieldName: 'id' },
  },
  customerId: {
    column1: { key: 'name', name: 'Item Name', fieldName: 'name' },
    column2: { key: 'id', name: 'ID', fieldName: 'id' },
  },
};

export const stagingColumnHeaders = {
  product: {
    column1: { key: 'name', name: 'Product Name', fieldName: 'name' },
    column2: { key: 'tokenId', name: 'ID', fieldName: 'id' },
    column3: { key: 'view', name: 'view' },
  },
  currency: {
    column1: { key: 'CurrencyName', name: 'Item Name', fieldName: 'CurrencyName' },
    column2: { key: 'CurrencyCode', name: 'ID', fieldName: 'CurrencyCode' },
  },
  geography: {
    column1: { key: 'countryName', name: 'Item Name', fieldName: 'ISOCountryEnglishShortName' },
    column2: { key: 'countryCode', name: 'ID', fieldName: 'ISOCountryNumber' },
  },
  channel: {
    column1: { key: 'ChannelTypeName', name: 'Item Name', fieldName: 'ChannelTypeName' },
    column2: { key: 'DerivedName', name: 'ID', fieldName: 'DerivedName' },
  },
  productTypeId: {
    column1: {
      key: 'productTypeDescription',
      name: 'Item Name',
      fieldName: 'ProductTypeDescription',
    },
    column2: { key: 'productTypeId', name: 'ID', fieldName: 'ProductTypeId' },
  },
  activityType: {
    column1: {
      key: 'activityTypeDescription',
      name: 'Item Name',
      fieldName: 'ActivityTypeDescription',
    },
    column2: { key: 'activityTypeId', name: 'ID', fieldName: 'ActivityTypeId' },
  },
  saleType: {
    column1: { key: 'saleTypeDescription', name: 'Item Name', fieldName: 'SaleTypeDescription' },
    column2: { key: 'saleTypeId', name: 'ID', fieldName: 'SaleTypeId' },
  },
  dataCenter: {
    column1: {
      key: 'azureDatacenters',
      name: 'Item Name',
      fieldName: 'DataCenter',
    },
    column2: { key: 'azureDatacentersId', name: 'ID', fieldName: 'DataCenter' },
  },
};

export const dlTypeNames = {
  product: {
    singular: 'product',
    plural: 'products',
  },
  currency: {
    singular: 'currency',
    plural: 'currencies',
  },
  channel: {
    singular: 'channel',
    plural: 'channels',
  },
  geography: {
    singular: 'country',
    plural: 'countries',
  },
  productTypeId: {
    singular: 'product type',
    plural: 'product types',
  },
  activityType: {
    singular: 'activity type',
    plural: 'activity types',
  },
  saleType: {
    singular: 'sale type',
    plural: 'sale types',
  },
  dataCenter: {
    singular: 'dataCenter',
    plural: 'dataCenters',
  },
  subscriptionGuid: {
    singular: 'subscriptionGuid',
    plural: 'subscriptionGuids',
  },
  tpId: {
    singular: 'tpId',
    plural: 'tpIds',
  },
  customerId: {
    singular: 'customerId',
    plural: 'customerIds',
  },
};

export const dlSilos = [
  {
    key: '3p-tla',
    text: '3P TLA',
  },
  {
    key: '1p-azure',
    text: '1P Azure',
  },
];

export const criticalFields = [
  'effectiveDate',
  'terminationDate',
  'contractCurrency',
  'metadata.paymentCurrency',
  'metadata.paymentTerms',
  'metadata.paymentStartDate',
  'metadata.vendorId',
];

export const driApiDelay = 30000;

export const deleteUserContent = {
  type: 'delete',
  title: 'Delete this User ?',
  content: 'The User will be permanently deleted. This action cannot be undone.',
  button: 'Yes, Delete',
  showCancelButton: true,
};

export const dimensionPropertyType = {
  computedValue: 'computedValue',
  list: 'dimensionList',
  value: 'value',
};

export const STATEMENT = {
  STATUS: {
    GENERATED: 'Generated',
    APPROVED: 'Approved',
    INVOICEGENERATED: 'InvoiceGenerated',
    INVOICEGENERATIONSKIPPED: 'InvoiceGenerationSkipped',
    INFLIGHT: 'InFlight',
    PENDING: 'Pending',
    REJECTED: 'Rejected',
    PREVIEW: 'Preview',
  },
};

export const operatorOptions = [
  {
    key: 'equals',
    text: 'Equals',
    label: '',
  },
  {
    key: 'not',
    text: 'Not Equals',
    label: '(Not Equals)',
  },
  ...(window.config.enableContainsOperator
    ? [
        {
          key: '>',
          text: 'Greater Than',
          label: '(Greater Than)',
        },
        {
          key: '>=',
          text: 'Greater Than Or Equal',
          label: '(Greater Than Or Equal)',
        },
        {
          key: 'contains',
          text: 'Contains',
          label: '(Contains)',
        },
        {
          key: 'notContains',
          text: 'Not Contains',
          label: '(Not Contains)',
        },
        {
          key: 'matchAll',
          text: 'Match All',
          label: '(Match All)',
        },
        {
          key: 'matchAny',
          text: 'Match Any',
          label: '(Match Any)',
        },
      ]
    : []),
];

export const operatorMap = new Map(
  operatorOptions.map(operator => {
    return [operator.key, operator.label];
  }),
);

export const ContractFilterStatus = Object.freeze({
  InSetup: 'inSetup',
  SetupComplete: 'setupComplete',
  Active: 'active',
  Expired: 'expired',
});

export const dlColumnKeys = {
  customerTier: 'customerTier',
};
